import { get, post, put, del, patch } from "../api_helper";
import * as url from "../url_helper";
import { convertObjectToParams } from "utils";

export const apiGetDevices = (data) => {
  let urlApi = url.API_GET_DEVICES;
  if (data) {
    const params = convertObjectToParams(data);
    urlApi = urlApi + "?" + params;
  }
  return get(urlApi);
};
export const apiPutDevices = (data) => put(url.API_GET_DEVICES, data);
export const apiPatchDevices = (id, data) =>
  patch(`${url.API_GET_DEVICES}${id}`, data);
export const apiDeleteDevices = (id) => del(`${url.API_GET_DEVICES}${id}`);
export const apiPairDevices = (data) => post(url.API_GET_DEVICES_PAIR, data);
export const apiUnPairDevices = (id, data) =>
  post(`${url.API_DELETE_SENSOR}${id}/unpair`, data);

export const apiGetAllDevices = (data) => post(url.API_GET_ALL_DEVICES, data)
export const apiDeleteDevice = (data) => post(url.API_DELETE_DEVICE, data)